import { Tooltip } from 'antd';
import { PlusOutlined, MinusOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button } from '../../../../../../design-system';
import { useTheme } from '../../../../../../providers/theme';
import { getColors } from '../../../../../utils/getColors';

interface FormWrapperProps {
  onAddRow: () => void;
  onRemoveRow: () => void;
  onClearAll?: () => void;
  showClearButton?: boolean;
  isSubmitting?: boolean;
  children: React.ReactNode;
  submitText?: string;
}

const FormWrapper = ({
  onAddRow,
  onRemoveRow,
  onClearAll,
  showClearButton = false,
  isSubmitting = false,
  children,
  submitText = 'Submit',
}: FormWrapperProps) => {
  const { isDay } = useTheme();
  const colors = getColors(isDay);

  return (
    <div className="form-container" style={{ border: `1px solid ${colors.border}` }}>
      {children}
      <div className="form-buttons">
        <div>
          <Button
            variant="primary"
            size="sm"
            startIcon={<PlusOutlined />}
            onClick={onAddRow}
          />
          <Button
            variant="ghost"
            size="sm"
            style={{ marginLeft: '0.5rem' }}
            startIcon={<MinusOutlined />}
            onClick={onRemoveRow}
          />
          {showClearButton && (
            <Tooltip title="Clear All Rows">
              <Button
                variant="ghost"
                size="sm"
                style={{ marginLeft: '0.5rem' }}
                startIcon={<DeleteOutlined />}
                onClick={onClearAll}
              />
            </Tooltip>
          )}
        </div>
        <div>
          <Button
            variant="secondary"
            style={{ marginLeft: '1rem' }}
            type="submit"
            loading={isSubmitting}
          >
            {submitText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FormWrapper;